module.exports = __webpack_public_path__ + "static/media/power-hp15.c7ffeade.png";